import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';




import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';


const MathWorkshop2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/math-workshop/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/math-workshop/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/math-workshop/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/math-workshop/4.webp`;
   
    const photos = [
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
 
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               MATH WORKSHOP
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Venue: Big AV Room    Date: 23 July 2025  <br />   Resource Person: Ms.Kakali Bagchi 
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                A workshop titled "Effective Ways of Teaching Mathematics" was conducted by Bharathi Bhavan Publishers to enhance mathematics instruction across Primary, Middle, and Secondary levels. The session was facilitated by Ms. Kakali Bagchi, an experienced educator, and designed within established curriculum frameworks to guide educators in developing strategies that help students progress from unconscious incompetence to unconscious competence in mathematics.  
                                    <br></br>
                                   Several significant pedagogical approaches were emphasised during the workshop. Complex mathematical problems were demonstrated to be effectively broken down into simpler, foundational questions through pictorial representations, making abstract concepts more concrete and accessible. The integration of Mathematics with Art, English, and Music was explored as a means of enhancing student learning and promoting a holistic understanding of mathematical concepts.<br></br>
                                   Additionally, the interconnected nature of mathematical concepts across grade levels was explored, illustrating how foundational skills from primary classes support advanced learning in higher grades, thereby emphasising the importance of sequential skill development.<br></br>
                                   Teachers from both host and guest schools participated in the collaborative learning environment. Engagement was fostered through interactive discussions, group activities, and problem-solving exercises that enriched the overall experience.
                                   <br></br>
                                   The session successfully transformed educators' perspectives on mathematics instruction, promoting interactive, visual, and creative teaching approaches. By moving away from traditional rote memorisation methods toward applied learning strategies, the workshop achieved its objective of equipping participants with practical insights to enhance their mathematics teaching effectiveness.
                                   
                                </Typography>
                            </Box>
                             <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default MathWorkshop2025;